import React from "react";

import { Link, useNavigate } from 'react-router-dom';
import { BsArrowLeftShort, BsPower } from 'react-icons/bs';
import logoImg from '../../assets/img/logo2.png'
import './style.css';






export default function AppBar(){
    const navigate = useNavigate();

    function handleLogout(){
        localStorage.clear();

        navigate('/');
    }

    return(

        <div className='app-bar'>
                
        <Link className="back-link" to="/home">
          <BsArrowLeftShort size={20} color="#1ABC9C"/>
          Voltar
        </Link>
        
        <img 
          src={logoImg} 
          alt="Dodo"
        />

        <button onClick={handleLogout} type="button">
            <BsPower size={18} color="#1ABC9C"/>
        </button>
      </div>

    );

};